import actionTypes from '../actions/actionsFactory/types';

export const INITIAL_STATE = {
  kycStatusInfo: {},
  fillInfo: {},
  statesInfo: [],
  senStatus: {},
  accountDetails: {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.GET_KYC_STATUS_SUCCESS:
      return {
        ...state,
        kycStatusInfo: action.data,
      };
    case actionTypes.GET_SEN_STATUS:
      return {
        ...state,
        senStatus: action.data || {},
      };
    case actionTypes.GET_ACCOUNT_DETAIL_SUCCESS:
      return {
        ...state,
        accountDetails: {
          ...action?.data,
          isVerified: action?.data.status === 1,
        },
      };
    case actionTypes.FETCH_FILL_INFO_SUCCESS:
      return {
        ...state,
        fillInfo: action.data,
      };
    case actionTypes.FETCH_US_STATES_INFO_SUCCESS:
      return {
        ...state,
        statesInfo: action.data,
      };
    default:
      return state;
  }
};
